import React, { PropTypes, Component } from 'react';

class ShowCategoryTemplateTwo extends Component {
  handleClick(e) {
    e.preventDefault();
  }
  render() {
    const showTermMeta = (TermMeta, index) => {
      const imgStyle = {
        backgroundImage: 'url(' + TermMeta.thumbnail_image.image_big_url + ')',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
      };
      return (<div key={'showCategory-' + index} className="category-with-img">
        <a style={imgStyle} href={this.props.taxonomy.permalink} className="category-normal">
           <div className="img-overlay"></div>
           <h5>{this.props.taxonomy.value}</h5>
        </a>
      </div>);
    };
    const imgStyle = {
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
    };
    return (
      <div className="rq-image-grid">
        {this.props.taxonomy.term_meta ? this.props.taxonomy.term_meta.map(showTermMeta) : null }
        {this.props.taxonomy.term_meta.length === 0 ?
        <div className="category-with-img">
          <a href={this.props.taxonomy.permalink} className="category-normal" style={imgStyle}>
            <div className="img-overlay"><i className="fa fa-frown-o"></i></div>
            <h5>{this.props.taxonomy.value}</h5>
          </a>
        </div> : null}
      </div>
    );
  }
}
ShowCategoryTemplateTwo.propTypes = {
  'taxonomy': React.PropTypes.object,
};
ReactiveTemplateCategories['showCategoryTemplateTwo'] = ShowCategoryTemplateTwo;

ReactiveCategories.push({
  'key': 'showCategoryTemplateTwo',
  // 'image_url': API.IMG + 'effect-steve.jpg',
  'type': 'all',
});



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/block/category/showCategoryTemplateTwo.js
 **/